import { render, staticRenderFns } from "./ValidationDeadline.vue?vue&type=template&id=15c297af&"
import script from "./ValidationDeadline.vue?vue&type=script&lang=ts&"
export * from "./ValidationDeadline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports